// components/Compliance/ComplianceDashboard.jsx - USE BACKEND DATA
import React from 'react';

const ComplianceDashboard = ({ recommendation }) => {
    // Use compliance data directly from backend
    const complianceChecks = recommendation?.compliance_checks || [];
    const complianceScore = recommendation?.compliance_score || 0;
    const overallStatus = recommendation?.overall_compliance_status || 'UNKNOWN';

    return (
        <div className="compliance-dashboard">
            <div className="compliance-header">
                <h3>
                    FCA Compliance Status: {Math.round(complianceScore * 100)}%
                    {complianceScore === 1 && ' ✓'}
                </h3>
                <div className="regulation-summary">
                    COBS 9.2.1R | COBS 9.2.2R | COBS 9.4 | PRIN 2A | COBS 4.2
                </div>
            </div>

            {complianceChecks.map(check => (
                <div key={check.regulation} className={`compliance-check ${check.status.toLowerCase()}`}>
                    <div className="check-header">
                        <span className="regulation">{check.regulation}</span>
                        <span className={`status-badge ${check.status.toLowerCase()}`}>
              {check.status === 'PASS' ? '✓ PASS' :
                  check.status === 'WARNING' ? '⚠ WARNING' :
                      '✗ FAIL'}
            </span>
                    </div>

                    <div className="check-details">
                        <p><strong>Evidence:</strong> {check.evidence}</p>
                        <div className="regulation-text">
                            <strong>Regulation:</strong> {check.regulation_text}
                        </div>
                        <a href={check.handbook_link} target="_blank" rel="noopener noreferrer">
                            📖 View FCA Handbook
                        </a>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ComplianceDashboard;